import { render, staticRenderFns } from "./mod20.vue?vue&type=template&id=2ecadf98&scoped=true&"
import script from "./mod20.vue?vue&type=script&lang=js&"
export * from "./mod20.vue?vue&type=script&lang=js&"
import style0 from "./mod20.vue?vue&type=style&index=0&id=2ecadf98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecadf98",
  null
  
)

export default component.exports